var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUpperCase = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    viewBox: "0 0 21 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.707 4.379H7.533l-3.328 9.863h2.562l.65-2.071h2.056a4.74 4.74 0 0 1 1.444-1.81c.457-.35.98-.617 1.544-.78zM7.984 10.36l1.095-3.497h.077l1.097 3.497z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CBB17",
    d: "M13.772 10.85a3.26 3.26 0 1 0 0 6.521 3.26 3.26 0 0 0 0-6.52m1.554 4.912a.39.39 0 0 1-.388.389h-2.332a.39.39 0 0 1-.388-.389v-1.943a.39.39 0 0 1 .388-.388h.195v-.389a.971.971 0 1 1 1.942 0v.39h.195c.213 0 .388.174.388.387zm-1.554-3.322a.603.603 0 0 0-.603.602v.39h1.205v-.39a.603.603 0 0 0-.602-.602m0 1.962a.39.39 0 0 0-.389.389.389.389 0 1 0 .389-.389",
    className: "lock"
  })));
};
export default SvgUpperCase;